// @flow
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import {
  ADD_ACCOMMODATION,
  ADD_TRANSPORT,
  ADD_SERVICE,
  DELETE_SERVICE,
  DISPLAY_TOAST_ON_CONTEXT_SHARE,
  UPDATE_SERVICES,
  ADD_ACCOMMODATION_ERROR,
} from 'Store/booking/proposals/constants';
import { FETCH_ADDITIONAL_ACCOMMODATIONS } from 'Store/booking/additional-accommodations/additionalAccommodations.action';
import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';
import { ROUTING_CHANGE } from 'Store/routing/constants';
import { UPDATE_BOOKING_CART } from 'Components/widgets/cart/bookingCart.actions';
import { NEWSLETTER_SUBSCRIPTION_VALIDATION } from 'Components/widgets/popin-newsletter/PopinNewsletter.jsx';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { CLOSE_TOAST } from './toast.actions';

type State = {
  shouldDisplay: boolean,
  label: string,
  icon: IconName,
  color: COLORS,
};

const initialState = {
  shouldDisplay: false,
  label: '',
  icon: ICONS.CONFIRMATION,
  color: COLORS.WATER_GREEN,
};

export const toast = (state: State = initialState, action: Action<*>) => {
  switch (action.type) {
    case resolve(ADD_ACCOMMODATION):
    case resolve(ADD_TRANSPORT):
      return {
        shouldDisplay: true,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        icon: ICONS.CONFIRMATION,
        color: COLORS.WATER_GREEN,
      };

    case DISPLAY_TOAST_ON_CONTEXT_SHARE:
    case NEWSLETTER_SUBSCRIPTION_VALIDATION:
      return {
        shouldDisplay: true,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        icon: ICONS.CONFIRMATION,
        color: COLORS.WATER_GREEN,
      };

    case resolve(ADD_SERVICE):
    case resolve(UPDATE_SERVICES):
    case resolve(DELETE_SERVICE):
    case resolve(UPDATE_BOOKING_CART):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        shouldDisplay: !!(
          get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel')
        ),
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        icon: ICONS.CONFIRMATION,
        color: COLORS.WATER_GREEN,
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        shouldDisplay: !!get(action, 'payload.toastLabel'),
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        icon: ICONS.CIRCLED_CROSS,
        color: COLORS.WATER_GREEN,
      };
    case 'PAYMENT_BUTTON_ERROR':
    case ADD_ACCOMMODATION_ERROR:
      return {
        shouldDisplay: !!action.payload.toastLabel,
        label: action.payload.toastLabel,
        icon: ICONS.CIRCLED_CROSS,
        color: COLORS.RED,
      };

    case UPDATE_SERVICES:
    case DELETE_SERVICE:
      return {
        ...state,
        shouldDisplay: false,
      };

    case CLOSE_TOAST:
    case ROUTING_CHANGE:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_TRANSPORTS:
      return {
        ...state,
        shouldDisplay: false,
      };

    default:
      return state;
  }
};
